
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[auctionId]/item-detail/[itemId]",
      function () {
        return require("private-next-pages/[auctionId]/item-detail/[itemId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[auctionId]/item-detail/[itemId]"])
      });
    }
  